import { useMutation, useQueryClient } from '@tanstack/react-query'

import { messageApi } from '../api/messageApi'
import { MESSAGE_TYPE } from '../models/Message.enums'
import { getConversationMessagesOptions } from './useConversationMessagesQuery'

type TCreatePrayMessage =
  | { conversationId: number; userId?: undefined }
  | { conversationId?: undefined; userId: number }

export const useCreatePrayMessageMutation = ({ conversationId, userId }: TCreatePrayMessage) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () =>
      messageApi.createMessage({ type: MESSAGE_TYPE.PRAYER, conversationId, users: userId ? [userId] : undefined }),
    onSuccess: ({ conversationId: id }) => {
      queryClient.invalidateQueries(getConversationMessagesOptions(id))
    },
  })
}
